import {IModalOptions} from "../../common/modals/modal-options.interface";

export class EcaConfirmInfoModalOptions implements IModalOptions {
  modalClasses = 'modal-eca modal-xl ';
  noButtonColour = 'transparent';
  noButtonIcon = '';
  noButtonText = 'Close';
  yesButtonColour = '';
  yesButtonIcon = '';
  yesButtonText = '';
  editButtonIcon = '';
}
